//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Cross from '~/assets/img/icons/Cross';

export default {
	components: { Cross },
};
